import { color, space, typography } from "styled-system";

import React from "react";
import { isTouch } from "../core-modules/utils";
import styled from "styled-components";

const RichTextBase = styled.div`
  ${color}
  ${typography}
  ${space}
  font-family: ${(props) => props.theme.fonts.main};
  & p,
  li {
    line-height: 1.5;
    font-size: ${(props) => {
      return props.large ? "20px;" : "16px;";
    }};
  }
  & *:not(:first-child) {
    margin-top: 40px;
  }
  & b,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    font-size: 20px;
  }
  & ul {
    list-style: disc;
    margin-left: 20px;
  }
  & li {
    margin-top: 15px !important;
  }
  & a {
    text-decoration: underline;
    color: ${(props) => {
      return props.theme.colors.midground;
    }};
  }
  & strong {
    font-family: ${(props) => {
      return props.theme.fonts.bold;
    }};
  }
  @media (min-width: 960px) {
    & p,
    li {
      font-size: ${(props) => {
        return props.large ? "22px;" : "18px;";
      }};
    }
    & b,
    & h2,
    & h3,
    & h4,
    & h5,
    & h6 {
      font-size: 22px;
    }
  }
`;

function RichText({ children, ...props }) {
  return (
    <RichTextBase
      {...props}
      dangerouslySetInnerHTML={{ __html: children }}
    ></RichTextBase>
  );
}
export default RichText;
